import { render } from "./BadgesCard.vue?vue&type=template&id=375d6202&scoped=true"
import script from "./BadgesCard.vue?vue&type=script&lang=js"
export * from "./BadgesCard.vue?vue&type=script&lang=js"

import "./BadgesCard.vue?vue&type=style&index=0&id=375d6202&scoped=true&lang=css"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/Whappy1/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-375d6202"]])

export default __exports__